import React, { useMemo } from "react";
import moment from "moment";
import { Grid, makeStyles } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { Value, Caption } from "../workOrderDetails";
import { useEntryStyle } from "./RelatedWork";
import { useFollowUpAttachments } from "../../../hooks/useFollowUpAttachments";
import { getThumbnailSrc } from "../../activityQuestions/utils/attachmentUtils";
const useStyles = makeStyles((theme) => ({
    headerRow: {
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
    },
    thumb: {
        width: 54,
        height: 54,
        borderRadius: 4,
        objectFit: "cover",
        background: "#fff",
    },
    columnFlex: {
        marginBottom: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        paddingRight: theme.spacing(2), // Add internal padding
    },
    caption: {
        wordBreak: "break-all",
    },
}));

const FollowUpAttachmentsRow = ({ referenceTicketNumber }) => {
    const entry = useEntryStyle();
    const classes = Object.assign(useStyles(), entry);
    const files = useFollowUpAttachments(referenceTicketNumber);

    const normalizedFiles = useMemo(
        () =>
            files.map((f) => ({
                ...f,
                uploadedOnText: f.uploadedOn instanceof Date ? f.uploadedOn.toLocaleString() : f.uploadedOn || "",
            })),
        [files],
    );

    return (
        <Grid item xs={12} className={classes.entrySpacing}>
            <Grid container className={classes.headerRow} alignItems="center" justifyContent="space-between">
                <Grid item xs={12}>
                    <Caption>
                        <FormattedMessage id="admin.work-order-details.attachments.header" defaultMessage="Attached files" />
                    </Caption>
                </Grid>
            </Grid>

            {normalizedFiles.map((file) => (
                <Grid key={file.id} container alignItems="flex-start">
                    <Grid item sm={12} md={1} className={classes.columnFlex}>
                        <img className={classes.thumb} src={getThumbnailSrc(file)} alt={file.fullFileName} />
                    </Grid>
                    <Grid item sm={12} md={3} className={classes.columnFlex}>
                        <Caption>
                            <FormattedMessage id="admin.work-order-details.attachments.file-col" defaultMessage="File" />
                        </Caption>
                        <Value className={classes.caption}>{file.fileNameNoExt}</Value>
                    </Grid>
                    <Grid item sm={12} md={1} className={classes.columnFlex}>
                        <Caption>
                            <FormattedMessage id="admin.work-order-details.attachments.type-col" defaultMessage="Type" />
                        </Caption>
                        <Value className={classes.caption}> {file.fileType}</Value>
                    </Grid>
                    <Grid item sm={12} md={2} className={classes.columnFlex}>
                        <Caption>
                            <FormattedMessage id="admin.work-order-details.attachments.uploaded-by-col" defaultMessage="Uploaded by" />
                        </Caption>
                        <Value> {file.uploadedBy}</Value>
                    </Grid>
                    <Grid item sm={12} md={2} className={classes.columnFlex}>
                        <Caption>
                            <FormattedMessage id="admin.work-order-details.attachments.uploaded-on-col" defaultMessage="Uploaded on" />
                        </Caption>
                        <Value> {moment(file.createdDateTime).format("LL H:mm")}</Value>
                    </Grid>
                    <Grid item sm={12} md={3} className={classes.columnFlex}>
                        <Caption>
                            <FormattedMessage id="admin.work-order-details.attachments.description-col" defaultMessage="Description" />
                        </Caption>
                        <Value> {file.fileDescription}</Value>
                    </Grid>
                </Grid>
            ))}
        </Grid>
    );
};

export default FollowUpAttachmentsRow;
